<template>
  <div class="EsharedDet" >
    <div class="centered-div">
      <div v-show="divOff">
        <el-form ref="form" :model="shareForm" label-width="0px" class="form">
          <el-row>
            <el-col :span="24">
              <div class="logo-top">
                <div class="logo-box">
                  <img class="logo" :src="imgLogo" />
                  <span class="logoTitle">迈思普电子股份有限公司</span>
                </div>
              </div>
<!--              <img class="logo" :src="imgLogo" />-->
<!--              <span class="logoTitle">{{迈思普电子股份有限公司}}</span>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="" prop="eshared_password">
                <el-input v-model="shareForm.eshared_password" style="width: 285px" placeholder="输入提取码 不区分大小写" maxlength="4" :disabled="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-button size="mini" type="primary" @click="shareFromClick()" style="margin: 0px 0px 0px 205px" :disabled="off">提取文件</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div v-show="tableOff" class="centered-div">
      <div class="logo-top">
        <div class="logo-box">
          <img class="logo" :src="imgLogo" />
          <span class="logoTitle">迈思普电子股份有限公司</span>
        </div>
      </div>
      <el-table :data="esharedData" :height="tableHeight" size="mini" style="width: 700px"
                :header-cell-style="{textAlign:'center', backgroundColor: '#FFFFFF', color: '#CFCFCF', fontSize: '15px', height: '30px'}" >
        <el-table-column label="图标" width="70px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <icon :name="efileIcon(scope.row)" :style="{color: efileIconColor(scope.row), height: 35 + 'px'}" class="efileIconDiv" ></icon>
          </template>
        </el-table-column>
        <el-table-column prop="mhfiles_file_dname" label="文件名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="eshared_crt_date" label="分享日期" width="130px" align="center" :formatter="timestampToTime" show-overflow-tooltip></el-table-column>
        <el-table-column prop="eshared_beg_date" label="有效日期" width="130px" align="center" :formatter="timestampToTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scope">
            <!--            <el-button-->
            <!--              size="mini"-->
            <!--              @click="getFile(scope.row, 'A')">预览</el-button>-->
            <el-button
              size="mini" round icon="el-icon-download"
              @click="getFile(scope.row, 'B')" >下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import EditBase from '@/components/form/EditBase.vue'
// import EditSlot from '@/components/form/EditSlot.vue'
// import TableColumn from '@/components/base/TableColumn.vue'
// import FormItem from '@/components/base/FormItem.vue'
export default {
  name: 'EsharedDet',
  mixins: [EditBase],
  data () {
    return {
      pageType: 'BASE',
      mainPostUrl: {
        queryUrl: '',
        postUrl: ''
      },
      mainObjectProps: {},
      mainRules: {},
      mainColumns: [],
      detPostUrl: {
        queryUrl: '',
        postUrl: ''
      },
      detObjectProps: {},
      detRules: {},
      detColumns: [],
      defaultQuery: [],
      queryColumns: [],
      fromData: {
        pod_status: ''
      },
      connectFromRules: {
        radio: [
          { required: true, message: '不能为空！', trigger: 'blur' }
        ]
      },
      connectVisible: false,
      connectForm: {
        radio: 24
      },
      configMap: {},
      shareVisible: false,
      shareForm: {
        eshared_url: '',
        eshared_password: ''
      },
      esharedData: [],
      tableHeight: window.innerHeight - 300,
      para: {},
      off: false,
      tableOff: false,
      divOff: true,
      imgLogo: require('../../assets/photo/loginlogo.png')
    }
  },
  components: {
    // TableColumn,
    // FormItem,
    // EditSlot
  },
  methods: {
    shareFromClick: async function () {
      // 校验
      if (this.para.code === '') {
        await this.$confirm('提取失败!链接错误，请复制完整链接, 请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } else {
        if (this.shareForm.eshared_password === '') {
          await this.$confirm('请输入提取码, 请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          // 调用提取
          const para = {
            nbr: this.para.code,
            password: this.shareForm.eshared_password,
            flag: 0,
            msg: ''
          }
          const { data: res } = await this.$http.post('/edoc/setEsharedDetChk', para)
          if (res.data.flag === -1) {
            // 执行查询
            await this.getTableData()
          } else {
            await this.$confirm(res.data.msg + '请确认', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          }
        }
      }
    },
    getTableData: async function () {
      const that = this
      this.tableOff = true
      this.divOff = false
      const para = {
        eshared_nbr: this.para.code
      }
      const { data: res } = await that.$http.post('/edoc/getEsharedDetByNbrList', para)
      if (res.data.length > 0) {
        this.esharedData = res.data
      } else {
        await this.$confirm('提取失败!数据失效, 请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
    },
    getFile (row, type) {
      const that = this
      if (type === 'B') {
        const p = {
          rootDirCode: 'SYSCFG_EDOC',
          rootDirField: 'sys_char2',
          filePath: row.mhfiles_file_path,
          // filePath: '\\SCMGRN.xlsx',
          fileName: row.mhfiles_file_dname,
          showFileName: row.mhfiles_file_dname,
          reConvert: false
        }
        const url = '/edoc/responseEdocFile'
        that.$http.post(url, p, {
          responseType: 'blob'
        }).then((response) => {
          const content = response.data
          const blob = new Blob([content])
          const aLink = document.createElement('a')
          const url = URL.createObjectURL(blob)
          if ('download' in aLink) {
            aLink.download = p.showFileName
            aLink.style.display = 'none'
            aLink.href = url
            document.body.appendChild(aLink)
            aLink.click()
            URL.revokeObjectURL(aLink.href)
            document.body.removeChild(aLink)
          } else {
            navigator.msSaveBlob(blob, p.showFileName)
          }
        })
      }
    },
    efileIcon (row) {
      const newName = row.mhfiles_file_dname
      const suffix = newName.substring(newName.lastIndexOf('.') + 1)
      if (suffix.toUpperCase() === 'PDF') {
        return 'file-pdf'
      } else if ((suffix.toUpperCase() === 'XLS') || (suffix.toUpperCase() === 'XLSX')) {
        return 'file-excel'
      } else if ((suffix.toUpperCase() === 'DOC') || (suffix.toUpperCase() === 'DOCX')) {
        return 'file-word'
      } else if ((suffix.toUpperCase() === 'PPT') || (suffix.toUpperCase() === 'PPTX')) {
        return 'file-powerpoint'
      } else if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
        return 'file-image'
      } else {
        return 'file'
      }
    },
    efileIconColor (row) {
      const newName = row.mhfiles_file_path
      const suffix = newName.substring(newName.lastIndexOf('.') + 1)
      if (suffix.toUpperCase() === 'PDF') {
        return '#FF1E1E'
      } else if ((suffix.toUpperCase() === 'XLS') || (suffix.toUpperCase() === 'XLSX')) {
        return '#34C724'
      } else if ((suffix.toUpperCase() === 'DOC') || (suffix.toUpperCase() === 'DOCX')) {
        return '#3370FF'
      } else if ((suffix.toUpperCase() === 'PPT') || (suffix.toUpperCase() === 'PPTX')) {
        return '#EC6810'
      } else if ((suffix.toUpperCase() === 'JPG') || (suffix.toUpperCase() === 'BMP') || (suffix.toUpperCase() === 'PNG') || (suffix.toUpperCase() === 'JPEG')) {
        return ''
      } else {
        return ''
      }
    },
    tableHeaderStyle ({ row, column, rowIndex, columnIndex }) {
      // if (rowIndex === 0 && columnIndex === 0) {
      //   return 'background-color: #afccfd; color: #000000;'
      // }
      return 'background-color: #afccfd; color: #000000;'
    },
    getChk: async function () {
      const that = this
      this.shareVisible = false
      // 解密
      const para = {
        eshared_nbr: this.para.code
      }
      const { data: res } = await that.$http.post('/edoc/getEsharedDetByNbr', para)
      if (res.data) {
        if (!res.data.eshared_in_effect) {
          this.off = true
          await this.$confirm('链接失效！无法提取文件, 请确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
      }
    },
    timestampToTime (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc != null) {
        const date = new Date(daterc)
        const year = date.getFullYear()
        /* 在日期格式中，月份是从0开始，11结束，因此要加0
         * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
         * */
        const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        // 拼接
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      }
    }
  },
  created () {
    this.para = this.$route.query
    this.getChk()
  },
  mounted () {
    // console.log(window.location.href) // 输出当前完整的URL
    // console.log(window.location.pathname) // 输出当前路径
    // console.log(window.location.search) // 输出查询字符串（?后面的部分）
    // console.log(window.location.hash) // 输出hash值（#后面的部分）
  }
}
</script>

<style lang="less" scoped>
.EsharedDet {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  height: 100vh;           /* 视口高度 */
}
.centered-div {
  position: absolute; /* 绝对定位 */
  justify-content: center;
  top: 100px;
  //top: 100px;            /* 向上偏移50% */
  //left: 50%;           /* 向左偏移50% */
  //transform: translate(-50%, -50%); /* 向上和向左移动自身宽高的50%，实现居中 */
}
.efileIconDiv {
  cursor: pointer;
  padding-left: 9px;
  padding-top: 9px;
}
.logo-top {
  .logo-box {
    display: flex;
    opacity: 1;
    .logo {
      width: 50px;
      height: 50px;
    }
    .logoTitle {
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      font-weight: bolder;
      padding-left: 15px;
    }
  }
}
.custom-header {
  background-color: red; /* 例如，设置为浅灰色 */
}

</style>
